import client from "./glossyApi";

let promise;
export const getFeatures = () => {
  promise = promise || client.get("/features").then((r) => r.data).catch(() => ({ listen: true, concierge: true }));
  return promise;
};
